import React from 'react';
import {ArrowGreenRight} from '../../styles/icons';
import { Link } from 'react-router-dom';

export default function Button({
    id,
    buttonType = 'button',
    buttonClass = '',
    buttonLabel,
    fullWidth = true,
    disabled,
    onClick,
    reactButtonClass = '',
    href,
    compact = false,
    small = true,
    hoverAnim = true,
    outline = false,
    primary = true,
    width,
    height,
    fs,
    arrowRight = false,
    textOnly = false
}) {
    return (
        // pass href null/undefined to disable right click menu options
        <div className={`${reactButtonClass} react-button`}>
            <Link to={href} rel='noopener noreferrer'>
                <button
                    id={id}
                    /* eslint-disable-next-line react/button-has-type */
                    type={buttonType}
                    className={`${fullWidth && !width ? 'w-100' : ''} ${compact ? 'compact' : ''} ${
                        small ? 'small' : ''
                    } ${hoverAnim ? 'button-hover-anim' : ''} ${primary ? 'primary' : ''} ${
                        outline ? 'outline-primary' : ''
                    }${textOnly ? 'text-button' : ''} ${buttonClass}`}
                    onClick={onClick}
                    disabled={disabled}
                    style={{
                        width,
                        height,
                        fontSize: fs
                    }}
                >
                    {buttonLabel}
                    {arrowRight && <ArrowGreenRight />}
                </button>
            </Link>
        </div>
    );
}
